export { ResumenConsumoProdTab } from "./ResumenConsumoProdTab";
